import {
  componentRuleListFromComponentManifest,
  type ComponentManifest,
} from "@airvantage/ui";

/**
 * Component rule list for mapping queries to view components.
 *
 * Each rule maps a query (type, method, multiple) to a component module path.
 * The first matching rule wins, so more specific rules should come first.
 */
export const COMPONENT_RULE_LIST = componentRuleListFromComponentManifest([
  {
    rules: [
      {
        query: { type: "apiClient", method: "read", multiple: true },
        componentModulePath: "components/APIClientList.js",
      },
      {
        query: { type: "apiClient", method: "read", multiple: false },
        componentModulePath: "components/APIClientData.js",
      },
      {
        query: { type: "apiClient", method: "create", multiple: false },
        componentModulePath: "components/APIClientData.js",
      },
      {
        query: { type: "group", method: "read", multiple: true },
        componentModulePath: "components/GroupListData.js",
      },
      {
        query: { type: "groupApplyRules", multiple: false },
        componentModulePath: "components/GroupApplyRulesData.js",
      },
      {
        query: { type: "group", method: "read", multiple: false },
        componentModulePath: "components/GroupData.js",
      },
      {
        query: { type: "group", method: "create", multiple: false },
        queryFilter: {
          operator: "exist",
          field: ["value", "systemSelection"],
        },
        componentModulePath: "components/GroupAdd.js",
      },
      {
        query: { type: "group", method: "create", multiple: false },
        componentModulePath: "components/GroupData.js",
      },
      {
        query: { type: "groupAccess", method: "read", multiple: false },
        componentModulePath: "components/GroupAccessData.js",
      },
      {
        query: { type: "groupAccess", method: "create", multiple: false },
        componentModulePath: "components/GroupAccessData.js",
      },
      {
        query: { type: "fleetSystem", method: "read", multiple: false },
        componentModulePath: "components/FleetSystemComplianceView.js",
      },

      // VPN views
      {
        query: { type: "vpn", method: "read", multiple: true },
        componentModulePath: "components/VpnList.js",
      },

      // Notification template views
      {
        query: {
          type: "notificationTemplate",
          method: "read",
          multiple: true,
        },
        componentModulePath: "components/NotificationTemplateListData.js",
      },
      {
        query: {
          type: "notificationTemplate",
          method: "read",
          multiple: false,
        },
        componentModulePath: "components/NotificationTemplateForm.js",
      },
      {
        query: {
          type: "notificationTemplate",
          method: "create",
          multiple: false,
        },
        componentModulePath: "components/NotificationTemplateForm.js",
      },
      {
        query: {
          type: "notificationCampaign",
          method: "read",
          multiple: true,
        },
        componentModulePath: "components/NotificationCampaignList.js",
      },
      // IMEI Lock views
      {
        query: { type: "imeiLock", multiple: false },
        componentModulePath: "components/IMEILockUnlock.js",
      },
      {
        query: { type: "imeiLock", multiple: true },
        componentModulePath: "components/IMEILockUnlockBulk.js",
      },
      {
        query: { type: "imeiLockUpdateResume", multiple: false },
        componentModulePath: "components/IMEILockUpdateIMEIAndResumeSIM.js",
      },
      {
        query: { type: "imeiLockResumeTerminate", multiple: false },
        componentModulePath: "components/IMEILockResumeTerminateSIM.js",
      },
    ],
  },
] as ComponentManifest<object>);
